module.exports = __webpack_public_path__ + "media/images/common/mob_pic-3b9565a4d225eff13dc2d101769df2c1.png";